import * as React from 'react'
import { Article } from '../articlesContainer'
import { Row, Col } from 'react-bootstrap'

interface ArticleStatsProps {
	article: Article
}

const ArticleStats: React.FunctionComponent<ArticleStatsProps> = (props) => {
	const totalClicks = props.article.variations.reduce((clicks, variation) => {
		return clicks + ((variation.clicks && +variation.clicks) || 0)
	}, 0)
	const totalImpressions = props.article.variations.reduce((imps, variation) => {
		return imps + ((variation.impressions && +variation.impressions) || 0)
	}, 0)
	const ctr = totalImpressions > 0 ? Math.round((totalClicks / totalImpressions) * 100 * 100) / 100 : 0
	return (
		<Row style={{ marginTop: '20px', marginBottom: '10px' }}>
			<Col xs={12}>
				<strong>Totals for the ad group: CTR:</strong> {ctr} % <strong>Clicks:</strong> {totalClicks}
			</Col>
		</Row>
	)
}

export default ArticleStats
